module.exports = __webpack_public_path__ + "img/1.1.fcf42a19.jpg";